<template>
    <div>
        <div class="d-flex justify-end pa-2">
            <v-btn-toggle v-model="selectedView" mandatory density="compact" rounded="lg">
                <v-btn value="table" prepend-icon="mdi-table">Tableau</v-btn>
                <v-btn value="search" prepend-icon="mdi-magnify">Recherche</v-btn>
            </v-btn-toggle>
        </div>
        <ProductTable v-if="showTable"></ProductTable>
        <ProductSearch v-else></ProductSearch>
    </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import ProductTable from "./ProductTable.vue";
import ProductSearch from "./ProductSearch.vue";

const DISPLAY_MODE_KEY = "displayMode";
const isValidDisplayMode = (mode: string | null): mode is "table" | "search" =>
    mode === "table" || mode === "search";

const selectedView = ref<"table" | "search">("table");

const showTable = computed(() =>
    selectedView.value === "table"
);

onMounted(() => {
    const displayMode = localStorage.getItem(DISPLAY_MODE_KEY);
    if (isValidDisplayMode(displayMode)) {
        selectedView.value = displayMode as "table" | "search";
    } else {
        selectedView.value = "table";
        localStorage.setItem(DISPLAY_MODE_KEY, selectedView.value);
    }
});

watch(selectedView, (newMode) => {
    localStorage.setItem(DISPLAY_MODE_KEY, newMode);
});
</script>